/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Order_Carrier_Delivery_Failed_DescInputs */

const vi_order_carrier_delivery_failed_desc = /** @type {(inputs: Order_Carrier_Delivery_Failed_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ghi rõ lý do đơn vị vận chuyển báo về (khách từ chối, sai địa chỉ, …). Bắt buộc nhập tối thiểu 3 ký tự.`)
};

/**

* @param {Order_Carrier_Delivery_Failed_DescInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const order_carrier_delivery_failed_desc = /** @type {((inputs?: Order_Carrier_Delivery_Failed_DescInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Order_Carrier_Delivery_Failed_DescInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_order_carrier_delivery_failed_desc(inputs)
});